import { render, staticRenderFns } from "./huangpu.vue?vue&type=template&id=991489d6&scoped=true"
import script from "./huangpu.vue?vue&type=script&lang=js"
export * from "./huangpu.vue?vue&type=script&lang=js"
import style0 from "./huangpu.vue?vue&type=style&index=0&id=991489d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991489d6",
  null
  
)

export default component.exports